import React from "react";
import InboxIcon from "@atlaskit/icon/core/inbox";

const ShowFullScopeVariablePathHint = () => {
  return (
    <p>
      <b>Hint:</b> Click the <InboxIcon label="" size="small" /> button in the upper-right corner for help with available data fields.
    </p>
  );
};
export default ShowFullScopeVariablePathHint;
